/**
 * Initializes accordions and search/filter functionality for knowledge collections.
 * 
 * - Sets up jQuery UI accordions with optional multiple open sections.
 * - Initializes List.js for searchable/filterable collections.
 * - Implements live search functionality.
 * - Uses Select2 for category filtering.
 * - Dynamically shows/hides collection groups based on search/filter results.
 * 
 * @since 1.0.0
 */
jQuery(document).ready(($) => {
	
	// Initialize accordions
	$('.elonu-knowledge-accordion').each(function() {
		const $cur = $(this);
	
		$cur.accordion({
			header: '> div.pane > .pane-title',
			collapsible: true,
			active: !$cur.hasClass('closed') ? 0 : false,
			heightStyle: 'content'
		});
	
		// Enable multiple open sections if `.open-multiple` is present
		if ($cur.hasClass('open-multiple')) {
			$cur.on('accordionbeforeactivate', (event, ui) => {
				const $currHeader = ui.newHeader.length ? ui.newHeader : ui.oldHeader;
				const $currContent = $currHeader.next('.ui-accordion-content');
				const isPanelSelected = $currHeader.attr('aria-selected') === 'true';
	
				// Toggle header & icon classes
				$currHeader.toggleClass('ui-accordion-header-collapsed ui-corner-all', isPanelSelected)
					.toggleClass('ui-accordion-header-active ui-state-active ui-corner-top', !isPanelSelected)
					.attr('aria-selected', (!isPanelSelected).toString());
	
				$currHeader.children('.ui-icon')
					.toggleClass('ui-icon-triangle-1-e', isPanelSelected)
					.toggleClass('ui-icon-triangle-1-s', !isPanelSelected);
	
				// Toggle panel content
				$currContent.toggleClass('ui-accordion-content-active', !isPanelSelected)
					.slideToggle(!isPanelSelected);
	
				return false; // Prevent default accordion behavior
			});
		}
	});
	
	const collectionLists = [];
	
	// Initialize List.js instances for each collection list
	$('.collection-list').each(function() {
		const $cur = $(this);
		const enableList = $cur.data('list');
		const listId = $cur.attr('id');
	
		if (enableList) {
			collectionLists.push(new List(listId, {
				valueNames: ['pane-title', 'pane-content', 'pane-cat'],
				searchClass: 'main-search'
			}));
		}
	});
	
	// Live search functionality
	const searchInput = $('.elon-knowledge-collection input.main-search');
	searchInput.on('input', function() {
		const searchTerm = $(this).val();
		collectionLists.forEach(list => list.search(searchTerm));
	});
	
	// Initialize category filter using Select2
	const mainFilter = $('.elon-knowledge-collection select.main-filter');
	mainFilter.select2({
		placeholder: 'Filter by Category',
		allowClear: true
	});
	
	// Filter results based on selected category
	mainFilter.on('select2:select', (e) => {
		const term = e.params.data.id;
		collectionLists.forEach(list => list.search(term));
		
		// Show only matching collection groups
		$('.collection-group').hide();
		$(`.collection-group-${term}`).show();
	});
	
	// Reset filter and show all results when cleared
	// Note: Using 'change' event for compatibility with older versions of Select2
	mainFilter.on('change', function() {
		if (!$(this).val()) { // Check if the value is cleared (empty)
			collectionLists.forEach(list => list.search());
			$('.collection-group').show();
		}
	});
	
	/*
	// Modern version of clearing/resetting (only works with newer versions of Select2)
	mainFilter.on('select2:clear', () => {
		collectionLists.forEach(list => list.search());
		$('.collection-group').show();
	});
	*/
	
	// Update collection visibility based on search/filter results
	collectionLists.forEach(list => {
		list.on('updated', (updatedList) => {
			const $parent = $(`#${updatedList.list.id}`).prev().parent();
			updatedList.matchingItems.length ? $parent.show() : $parent.hide();
		});
	});
	
});